import { render, staticRenderFns } from "./DonatePrimeDetail.vue?vue&type=template&id=10903682&scoped=true&"
import script from "./DonatePrimeDetail.vue?vue&type=script&lang=js&"
export * from "./DonatePrimeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10903682",
  null
  
)

export default component.exports